module.exports = __webpack_public_path__ + "img/circle.50f7a040.svg";